import React from 'react';
import MainContentForScenarioSelectionRedefined
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import MainContentDefault
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentDefault';

const MainContentPicker = ({ previewResource, setPreviewCollection }) => {
  return pick(previewResource, {
    [fr.relationships.facetPlanProposalPreviewRedefinedContent.name]: (<MainContentForScenarioSelectionRedefined resource={previewResource} setPreviewCollection={setPreviewCollection} />),
  }, <MainContentDefault resource={previewResource} />);
};

MainContentPicker.defaultProps = {
};

MainContentPicker.propTypes = {
  previewResource: PropTypes.instanceOf(fr.Resource).isRequired,
  setPreviewCollection: PropTypes.func.isRequired,
};

export default MainContentPicker;
